module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/a1@2x_e3ab9fa5bc28ff3d9e946700ee396806.png";